const config = {
  company: 'Atlas GmbH' || 'vib GmbH',
  logoURI:
    'https://utils.vib-development.ch/atlas/logo.svg' || 'https://utils.vib-development.ch/vib/logo.svg',
  logoWhiteURI:
    'https://utils.vib-development.ch/atlas/logo_white.svg' || 'https://utils.vib-development.ch/vib/logo-white.svg',

  address: 'Atlas GmbH,Atlasstraße 6,27777 Ganderkesee'?.split(',') || [
    'vib GmbH',
    'Grabenstrasse 12',
    '6340 Baar',
  ],
  contact: 'Telefon +49 (04222) – 954 – 0,info@atlasgmbh.com'?.split(',') || [
    '+41 (0)41 763 16 94',
    'support@vib-gmbh.ch',
  ],
  apibaseuri:
    'https://api.atlas-manual.vib-connect.com' ||
    'https://api.main.vib-connect-manual.ch4.amazee.io',
  appname: 'Atlas GmbH ECM Manual' || 'vib connect Manual',
  appdomain: 'atlas-manual.vib-connect.com' || 'manual.vib-gmbh.ch',
  appurl: 'https://atlas-manual.vib-connect.com' || 'https://manual.vib-gmbh.ch',
  statuspage: 'https://status.vib-development.ch' || 'https://status.vib-development.ch',
  support: 'support@vib-connect.com' || 'support@vib-gmbh.ch',
  root: '1KRu_aXw5mpfctf4nEyvjavks_y5PqJK1' || '',
  footer: '1MdLoZEsOmU9vosCL4Xlyy-DJ7oXOomaIGXZAIAvaO-0' || '',
  disclaimer: '1oMrhunvr_UsyYB1qeiGx4Hc1n-vde7oFJcowfHhLD9Y' || '',
  languages: 'DE'?.split(',') || ['DE','EN-GB'],
  screenBreak: '930' || 930
};

export default config;
